var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble bubble--fluid",class:{
        'is-open': _vm.isOpen,
        'is-shrunk': _vm.isShrunk,
    },style:({ width: _vm.width, transform: _vm.transform, opacity: _vm.opacity })},[_c('div',{staticClass:"bubbleName"},[_vm._v(_vm._s(_vm.$t(_vm.name)))]),_c('div',{staticClass:"bubbleBG--fluid",style:({
            transform: _vm.innerTransform
        })},[_c('div',{staticClass:"fluid-bubble__filler",class:'color-filter--' + _vm.backgroundColor.toLowerCase(),style:(("backgroundPosition: " + ((_vm.isFillReady) ? 708 : 0) + "px 0; transform: translateY(" + (95 - _vm.fill) + "%);"))})])])}
var staticRenderFns = []

export { render, staticRenderFns }